import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { fade } from '@material-ui/core/styles/colorManipulator';
import { withStyles } from '@material-ui/core/styles';

import ErrorIcon from '@material-ui/icons/Error';
import Typography from 'fuse-ui/components/Typography';

import { accent } from '../theme/colors';

const styles = theme => ( {
    container: {
        background: fade( accent.orangeMain, .08 ),
        display: 'flex',
        padding: `${theme.spacing.unit}px ${theme.spacing.unit * 3}px`,
        width: '100%',
    },
    errorIcon: {
        color: accent.orangeMain,
        height: theme.spacing.unit * 2,
        marginRight: theme.spacing.unit / 2,
        width: theme.spacing.unit * 2,
    },
    noPadding: {
        margin: `0 -${theme.spacing.unit * 3}px`,
        width: `calc(100% + ${theme.spacing.unit * 6}px)`
    }
} );

const Warning = ( { children, classes, color, noPadding } ) => {
    return (
        <div className={cx( classes.container, { [classes.noPadding]: noPadding } )}>
            <ErrorIcon className={classes.errorIcon} />
            <Typography variant="caption" color={color}>{children}</Typography>
        </div>
    );
};

Warning.propTypes = {
    children: PropTypes.string,
    classes: PropTypes.object,
    color: PropTypes.string,
    noPadding: PropTypes.bool.isRequired,
};
Warning.defaultProps = {
    color: 'textPrimary',
    noPadding: false
};

export default withStyles( styles )( Warning );
